<template>
  <b-form-group
    label="Üst Grup"
    label-for="title"
  >
    <v-select
      v-model="dataItem.id_donation_groups"
      :options="donationGroups"
      label="title"
      :reduce="item => item.id"
      placeholder="Ana Grup"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'DonationGroups',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
    donationGroups() {
      return this.$store.getters['donationGroups/dataList']
    },
  },
  created() {
    this.getDonationGroups()
  },
  methods: {
    getDonationGroups() {
      this.$store.dispatch('donationGroups/getDataList', {
        select: [
          'donation_groups.id AS id',
          'donation_groups.title AS title',
        ],
        where: {
          'donation_groups.id_donation_groups': null,
          'donation_groups.is_expense': 1,
        },
      })
    },
  },
}
</script>
